import { useSelector } from 'react-redux';
import {
  getAnnouncements,
  getIsAnnouncementsUpdatedAt,
} from '../../stores/announcements/getters';
import { useEffect, useState } from 'react';
import { dateMoment } from '../../utils';

function filterData(dataRaw = []) {
  const newData = [];

  const nowMoment = dateMoment();
  const today = dateMoment().startOf('d');

  for (let index = 0; index < dataRaw.length; index++) {
    const element = dataRaw[index];

    if (!element.dismissable) {
      newData.push(element);
      continue;
    }

    if (!element.dismissedAt) {
      newData.push(element);
      continue;
    }

    // filter out: no reappear
    if (!element.reappear) {
      continue;
    }

    if (!element.expiresAt) {
      continue;
    }

    const expiresAtMoment = dateMoment(element.expiresAt);

    if (expiresAtMoment.isBefore(nowMoment)) {
      continue;
    }

    const dismissedAtMoment = dateMoment(element.dismissedAt);

    if (dismissedAtMoment.isAfter(today)) {
      continue;
    }

    newData.push(element);
  }

  return newData;
}

export default function useAnnouncementData() {
  const dataRaw = useSelector(getAnnouncements);
  const updatedAt = useSelector(getIsAnnouncementsUpdatedAt);
  const [data, setData] = useState(filterData(dataRaw));

  useEffect(() => {
    setData(filterData(dataRaw));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedAt]);

  return data;
}
